export type MultipartAudioStatus = 'idle' | 'completing' | 'aborting'

export interface MultipartAudioPartDto {
    /** Optional in the S3 SDK's UploadPart output and CompletedPart input. */
    ETag: string | undefined
    PartNumber: number
}

export class MultipartAudioDto {
    constructor(
        public key: string,
        public uploadId: string,
        public parts: MultipartAudioPartDto[] = [],
        public partNumber: number = 1,
        public bucket: string,
        public size: number = 0
    ) {}

    static empty(
        bucket: string,
        key: string,
        uploadId: string
    ): MultipartAudioDto {
        return new MultipartAudioDto(key, uploadId, [], 1, bucket, 0)
    }

    addPart(part: MultipartAudioPartDto, size: number): void {
        this.parts.push(part)
        this.partNumber++
        this.size += size
    }

    sortParts(): void {
        this.parts.sort((a, b) => a.PartNumber - b.PartNumber)
    }
}
